export const mapFilterOptions = (options) => {
  const filterOptions = options.map((option) => {
    return option.title;
  });
  return filterOptions;
};

export const mapFilterOptionsCode = (options) => {
  const filterOptions = options.map((option) => {
    return option.code;
  });
  return filterOptions;
};

export const OptionsFromColumns = (rows, column) => {
  if (!Array.isArray(rows)) return [];
  
  const uniqueOptions = [...new Set(rows.map((row) => row[column]))];
  return uniqueOptions.filter(option => option != null && option !== "");
};